module.exports = __webpack_public_path__ + "img/logo.97e91b87.jpg";